import ProjectConfig from 'ProjectConfig';

const CONTENT_URL = ProjectConfig.CONTENT_URL ? new URL(ProjectConfig.CONTENT_URL) : null;

export default fileName => {
  if (!CONTENT_URL) {
    return `/media/cms/photos/${fileName}`;
  }
  return `${CONTENT_URL.origin}/media/cms/photos/${fileName}`;
};

